var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.urlList.length>0)?_c('div',{staticClass:"imgUrl"},_vm._l((_vm.urlList),function(item,index){return _c('img',{key:index,staticStyle:{"width":"100%"},attrs:{"src":`${_vm.imgUrl}/${item}`,"alt":""}})}),0):_c('div',[_c('el-empty',{attrs:{"image-size":200}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }